import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '@/api/client';
import { Calendar, MapPin, Users, BabyIcon, CheckCircle2 } from 'lucide-react';

export default function RSVPHistory() {
  const { data: rsvps = [] } = useQuery({ queryKey: ['my-rsvps-full'], queryFn: async () => (await api.get('/member/rsvps')).data });

  return (
    <div className="space-y-6">
      <div className="card-moj p-6">
        <h1 className="font-serif text-2xl text-moj-purple-deep flex items-center gap-2 mb-2"><Calendar/> My RSVPs</h1>
        <p className="text-sm text-moj-charcoal/70">Events you have responded to so far.</p>
      </div>
      {rsvps.length === 0 && <div className="card-moj p-10 text-center text-moj-charcoal/60">You haven’t RSVP’d to any events yet.</div>}
      <div className="space-y-3">
        {rsvps.map((r) => (
          <div key={r.id} className="card-moj p-5 flex flex-wrap items-center gap-4">
            <CheckCircle2 size={28} className="text-moj-purple"/>
            <div className="flex-1">
              <div className="font-serif text-lg text-moj-purple-deep">{r.event_title}</div>
              <div className="flex flex-wrap gap-3 text-xs text-moj-charcoal/70 mt-1">
                <span>RSVP’d {r.created_at?.slice(0, 10)}</span>
                <span><Users size={12} className="inline"/> {r.adults_count} adults</span>
                {r.children_count > 0 && <span><BabyIcon size={12} className="inline"/> {r.children_count} children</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
